import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, vModelSelect as _vModelSelect, mergeProps as _mergeProps, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cb2a823"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "clearableContainer" }
const _hoisted_2 = {
  key: 0,
  class: "clearBtn"
}

import {computed} from 'vue';

export default /*#__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false
},
  __name: 'ClearableSelect',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emits = __emit;
const selection = computed({
    get() {
        return props.modelValue;
    },
    set(val) {
        emits('update:modelValue', val);
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (selection.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (selection.value=null))
          }, "x")
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("select", _mergeProps({ class: "clearable" }, _ctx.$attrs, {
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selection).value = $event))
    }), [
      _renderSlot(_ctx.$slots, "default")
    ], 16), [
      [_vModelSelect, selection.value]
    ])
  ]))
}
}

})